<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: liyong
 * @Date: 2022-06-06 14:56:23
 * @LastEditors: liyong
 * @LastEditTime: 2022-06-24 16:39:39
 * @FilePath: /partner.chaoyongtuan.com/src/views/common/dialog/authStatusResult.vue
 * 
 * Copyright (c) 2022 by 央选/李勇, All Rights Reserved. 
-->
<template>
	<div>
		<el-dialog class="success" :visible="successVisible" :show-close="false" width="392px" :close-on-click-modal="false">
			<div slot="title"></div>
			<div class="flex-column flex-align-center">
				<i class="el-icon-success yx-color-success success"></i>
				<p class="fz-18 mt-26 mb-30">店铺授权成功！</p>
				<div class="mt-10 mb-10">
					<el-button type="primary" @click="ok">我知道了</el-button>
				</div>
			</div>
		</el-dialog>
		<el-dialog title="提示" :visible="failVisible" width="392px" :close-on-click-modal="false">
			<div class="fz-14 mt-8 flex flex-align-center">
				<img src="@/assets/public/warning-org.png" class="warn-img" alt="" />
				<div class="ml-6">
					校验到您授权异常，请
					<span v-if="$isDy()">根据下方教程提示关闭授权后，再重新授权或</span>
					<el-tooltip placement="top">
						<img slot="content" :src="baseInfo.partner_auth_code" alt="" width="160" height="160" />
						<a href="javascript:;" class="fz-14 ml-6 mr-6 yx-color-primary">联系客服</a>
					</el-tooltip>
					<span v-if="!$isDy()">协助您解决</span>
				</div>
			</div>
			<div slot="footer" class="dialog-footer flex flex-just-between">
				<div class="ml-18 fz-14">
					<a v-if="$isDy()" target="_blank" href="https://yangxuan.feishu.cn/docs/doccnry7mJfGmsm6O5Qk6XNnXbd" class="yx-color-primary">
						查看授权异常处理
					</a>
				</div>
				<el-button @click="close">关闭</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
import mixin from '@/mixins';
import { checkAuthorize } from '@/api/shopManage';
export default {
	mixins: [mixin],
	data() {
		return {
			successVisible: false,
			failVisible: false,
			platformId: '',
			link: '',
		};
	},
	methods: {
		show(flag, platformId, link) {
			this.platformId = platformId;
			if (flag) return (this.successVisible = true);
			this.checkAuthorize(link);
		},
		ok() {
			this.successVisible = false;
			this.$router.push({ query: {} });
		},
		async checkAuthorize(link) {
			if (link) return (this.link = link), (this.failVisible = true);
			const data = await checkAuthorize({ platform_id: this.platformId });
			this.link = data.institution_url;
			this.failVisible = true;
		},
		close() {
			this.failVisible = false;
			this.$router.push({ query: {} });
		},
		again() {
			var a = document.createElement('a'); // 创建a标签
			a.style.display = 'none'; // 隐藏a标签
			a.href = this.link; // 文件下载地址
			a.target = '_blank';
			document.body.appendChild(a); // 将a标签插入到页面中
			a.click(); // 强制触发a便签的点击事件
			document.body.removeChild(a); // 移除a标
		},
	},
};
</script>
<style lang='less' scoped>
.success {
	/deep/ .el-dialog__header {
		border: 1px solid transparent;
	}
	.success {
		font-size: 52px;
	}
}
.warn-img {
	width: 16px;
	height: 16px;
}
</style>